export const CardData = [
    {
        name: 'HR GS Service',
        icon: '/media/icons/tribes/hrgs.svg',
        link: 'hrgs'
    },
    {
        name: 'PSCM Service',
        icon: '/media/icons/tribes/pscm.svg',
        link: 'pscmservice'
    },
    {
        name: 'Finance Service',
        icon: '/media/icons/tribes/finance.svg',
        link: 'financeservice'
    }
];
